<template>
  <div class="login-container">
    <div class="overlay-text">
      <h2>欢迎使用瓜子看点系统</h2>
      <p>高效、安全、可靠的小说变现平台</p>
    </div>

    <div class="form-wrapper">
      <el-tabs v-model="activeTab" stretch>
        <el-tab-pane label="用户登录" name="login">
          <el-form :model="loginForm" :rules="loginRules" ref="loginFormRef">
            <el-form-item prop="username">
              <el-input v-model="loginForm.username" placeholder="请输入账号" prefix-icon="User" clearable />
            </el-form-item>

            <el-form-item prop="password">
              <el-input v-model="loginForm.password" type="password" placeholder="请输入密码" prefix-icon="Lock"
                show-password clearable />
            </el-form-item>

            <el-form-item>
              <el-checkbox v-model="rememberMe" label="记住密码" style="margin-bottom: 15px;" />
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="handleLogin" :loading="loading" style="width: 100%">
                登录
              </el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>

        <el-tab-pane label="用户注册" name="register">
          <el-form :model="registerForm" :rules="registerRules" ref="registerFormRef">
            <el-form-item prop="avatar">
              <div class="avatar-upload-container">
                <el-upload
                  class="avatar-uploader"
                  action="#"
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload"
                  :http-request="handleAvatarUpload"
                >
                  <div class="avatar-preview" :class="{ 'has-avatar': registerForm.avatar }">
                    <img v-if="registerForm.avatar" :src="registerForm.avatar" class="avatar" />
                    <div v-else class="avatar-placeholder">
                      <el-icon class="avatar-icon"><User /></el-icon>
                      <span class="avatar-text">上传头像</span>
                    </div>
                  </div>
                </el-upload>
              </div>
            </el-form-item>

            <el-form-item prop="nickname">
              <el-input v-model="registerForm.nickname" placeholder="请输入快手或抖音昵称" prefix-icon="User" clearable />
            </el-form-item>

            <el-form-item prop="username">
              <el-input v-model="registerForm.username" placeholder="请输入手机号" prefix-icon="Phone" clearable />
            </el-form-item>

            <el-form-item prop="password">
              <el-input v-model="registerForm.password" type="password" placeholder="请输入密码" prefix-icon="Lock"
                show-password clearable />
            </el-form-item>

            <el-form-item prop="inviteCode">
              <el-input v-model="registerForm.inviteCode" placeholder="请输入邀请码，如无可留空或填写1" prefix-icon="Star" clearable />
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="handleRegister" :loading="loading" style="width: 100%">
                注册
              </el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Compressor from 'compressorjs';

export default {
  name: 'LoginPage',
  data() {
    return {
      activeTab: 'login',
      loading: false,
      rememberMe: false,
      captchaCountdown: 0,
      loginForm: {
        username: '',
        password: ''
      },
      registerForm: {
        avatar: '',
        nickname: '',
        username: '',
        password: '',
        inviteCode: ''
      },
      loginRules: {
        username: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      registerRules: {
        avatar: [
          { required: true, message: '请上传头像', trigger: 'change' }
        ],
        nickname: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
        username: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号格式', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        inviteCode: []
      }
    }
  },
  methods: {
    async handleLogin() {
      this.$refs.loginFormRef.validate(async valid => {
        if (valid) {
          this.loading = true;
          try {
            const response = await this.$axios.post(`api/Bloger/login`, {
              username: this.loginForm.username,
              password: this.loginForm.password
            });
            console.log(response)
            if (response.code == 0) {
              this.$message.error(response.msg || '登录失败');
              return;
            }
            const token = response.data.userinfo.token;
            const userInfo = response.data.userinfo;
            console.log('登录成功，token:', token);
            this.$store.dispatch('setToken', token);
            this.$store.dispatch('setUserInfo', userInfo);

            if (this.rememberMe) {
              localStorage.setItem('savedUsername', this.loginForm.username);
              localStorage.setItem('savedPassword', this.loginForm.password);
            } else {
              localStorage.removeItem('savedUsername');
              localStorage.removeItem('savedPassword');
            }
            this.$message.success(response.msg || '登录成功');
            this.$router.push('/dashboard');
          } catch (error) {
            console.error('登录失败:', error);
            this.$message.error(error?.data?.msg || '登录失败');
          } finally {
            this.loading = false;
          }
        }
      });
    },
    async handleRegister() {
      this.$refs.registerFormRef.validate(async valid => {
        if (valid) {
          this.loading = true;
          try {
            const response = await this.$axios.post(`api/Bloger/register`, {
              nickname: this.registerForm.nickname,
              username: this.registerForm.username,
              password: this.registerForm.password,
              avatar: this.registerForm.avatar,
              inviteCode: this.registerForm.inviteCode || '1'
            });
            if (response.code == 0) {
              this.$message.error(response.msg || '注册失败');
              return;
            }
            this.$message.success('注册成功');
            this.activeTab = 'login';
            this.loginForm.username = this.registerForm.username;
            this.loginForm.password = this.registerForm.password;
            this.$refs.registerFormRef.resetFields();


          } catch (error) {
            this.$message.error(error.response?.data?.msg || '注册失败');
          } finally {
            this.loading = false;
          }
        }
      });
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        return false;
      }
      return true;
    },
    async handleAvatarUpload(file) {
      try {
        // 压缩图片并保持宽高比
        new Compressor(file.file, {
          quality: 0.7,
          width: 120,
          height: 120,
          resize: 'cover', // 保持宽高比并裁剪
          convertSize: 5000000,
          mimeType: 'image/jpeg',
          success: async (compressedFile) => {
            try {
              const formData = new FormData()
              const fileName = file.name ?
                file.name.replace(/\.[^/.]+$/, '.jpg') :
                `avatar_${Date.now()}.jpg`
              const finalFile = new File([compressedFile], fileName, {
                type: 'image/jpeg',
                lastModified: Date.now()
              })
              formData.append('file', finalFile)

              const response = await this.$axios.post('api/Bloger/upload', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'token': localStorage.getItem('token') || ''
                },
                timeout: 30000
              })

              if (response.data && response.code == 1) {
                this.registerForm.avatar = response.data.url
                this.$message.success('头像上传成功')
              } else {
                this.$message.error('头像上传失败: ' + (response.message || '未知错误'))
              }
            } catch (uploadError) {
              console.error('上传失败:', uploadError)
              this.$message.error('头像上传失败')
            }
          },
          error: (err) => {
            console.error('图片压缩失败:', err)
            this.$message.error('头像处理失败')
          }
        })
      } catch (error) {
        console.error('处理头像失败:', error)
        this.$message.error('处理头像失败')
      }
    },
    loadSavedCredentials() {
      const username = localStorage.getItem('savedUsername');
      const password = localStorage.getItem('savedPassword');
      if (username && password) {
        this.loginForm.username = username;
        this.loginForm.password = password;
        this.rememberMe = true;
      }
    },
    // 加载自动填充的登录数据
    loadAutoLoginData() {
      const autoLoginData = localStorage.getItem('autoLoginData');
      if (autoLoginData) {
        try {
          const { username, password } = JSON.parse(autoLoginData);
          if (username && password) {
            this.loginForm.username = username;
            this.loginForm.password = password;
            // 清除自动填充数据，避免重复使用
            localStorage.removeItem('autoLoginData');
            
            // 显示提示信息
            this.$message.success('密码已修改，账户和新密码已自动填入，请重新登录');
          }
        } catch (error) {
          console.error('解析自动登录数据失败:', error);
          localStorage.removeItem('autoLoginData');
        }
      }
    }
  },
  mounted() {
    this.loadSavedCredentials();
    
    // 检查是否有自动填充的登录数据（密码修改后）
    this.loadAutoLoginData();
    
    if (this.$store.getters.token) {
      this.$router.push('/home');
    }
  }
}
</script>

<style scoped>
.login-container {
  position: relative;
  height: 100vh;
  background: url('@/assets/login-bg.png') no-repeat center center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.form-wrapper {
  width: 100%;
  max-width: 380px;
  padding: 30px;
  background: #fff;
  backdrop-filter: blur(10px);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  margin-top: 20px;
}

.overlay-text {
  color: white;
  max-width: 400px;
  text-align: center;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
  margin-bottom: 20px;
}

@media (min-width: 992px) {
  .login-container {
    flex-direction: row;
    justify-content: space-between;
    padding: 0 10%;
  }

  .form-wrapper {
    position: static;
    transform: none;
    margin-top: 0;
  }

  .overlay-text {
    position: static;
    transform: none;
    text-align: left;
    margin-bottom: 0;
  }
}

.overlay-text h2 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: #FFFFFF;
  font-weight: bold;
}

.overlay-text p {
  font-size: 1.2rem;
  color: #fff;
}

.el-tabs__item {
  font-size: 18px;
  color: #666;
}

.el-tabs__item.is-active {
  color: #FFFFFF;
}

.el-tabs__active-bar {
  background-color: #6babf3;
}

.el-button--primary {
  background-color: #6babf3;
  border-color: #6babf3;
  border-radius: 20px;
  font-size: 16px;
  height: 45px;
}

.el-button--primary:hover {
  background-color: #6babf3;
  border-color: #6babf3;
}

.el-input {
  --el-input-border-radius: 20px;
  --el-input-height: 48px;
  --el-input-bg-color: rgba(255, 255, 255, 0.8);
  --el-input-border-color: rgba(40, 148, 221, 0.5);
  --el-input-hover-border-color: #6babf3;
  --el-input-focus-border-color: #6babf3;
  margin-bottom: 20px;
}

.el-input__inner {
  padding-left: 40px;
  color: #666;
  font-size: 16px;
}

.el-input__prefix {
  color: #6babf3;
  left: 12px;
}

.el-input__suffix {
  right: 12px;
}

.el-input__wrapper {
  box-shadow: 0 2px 8px rgba(255, 133, 162, 0.1);
}

.el-input__wrapper:hover {
  box-shadow: 0 2px 12px rgba(255, 133, 162, 0.2);
}

.el-input__wrapper.is-focus {
  box-shadow: 0 2px 12px rgba(255, 133, 162, 0.3);
}

.el-form-item {
  margin-bottom: 25px;
}

.captcha-container {
  display: flex;
  gap: 10px;
  align-items: stretch;
}

.captcha-input {
  flex: 1;
}

.captcha-input .el-input__wrapper {
  height: 48px;
  box-sizing: border-box;
}

.captcha-btn {
  white-space: nowrap;
  min-width: 120px;
  height: 48px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 头像上传样式 */
.avatar-upload-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.avatar-uploader {
  display: flex;
  justify-content: center;
  width: 100%;
}

.avatar-uploader .el-upload {
  border: 2px dashed #6babf3;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  transition: all 0.3s ease;
}

.avatar-uploader .el-upload:hover {
  border-color: #6babf3;
  background-color: #e8e8e8;
  transform: scale(1.05);
}

.avatar-preview {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: #f5f5f5;
}

.avatar-preview.has-avatar {
  background-color: transparent;
}

.avatar {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.avatar-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 80px;
  height:  80px;
  color: #6babf3;
  border-radius: 50%;
  background-color: #f5f5f5;
}

.avatar-icon {
  font-size: 36px;
  margin-bottom: 8px;
  transition: all 0.3s ease;
}

.avatar-text {
  font-size: 12px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.avatar-uploader .el-upload:hover .avatar-icon {
  color: #6babf3;
  transform: scale(1.1);
}

.avatar-uploader .el-upload:hover .avatar-text {
  color: #6babf3;
}

/* 强制 el-upload 组件为圆形 */
.avatar-uploader .el-upload,
.avatar-uploader .el-upload-dragger {
  border-radius: 50% !important;
}

.avatar-uploader .el-upload-dragger {
  width: 120px !important;
  height: 120px !important;
  border-radius: 50% !important;
  background-color: #f5f5f5 !important;
}
</style>
